import type { SerializedError } from '@reduxjs/toolkit';

import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import initialConfig from '../initialConfig';

const initialState: {
  anonymous_activityBlogData: any;
  anonymous_activityBlogLoading: boolean;
  anonymous_activityBlogError: SerializedError | null;
} = {
  anonymous_activityBlogData: {},
  anonymous_activityBlogLoading: false,
  anonymous_activityBlogError: null,
};

export const anonymous_activityBlogFunc = createAsyncThunk(
  'anonymous_activityBlog/anonymous_activityBlogFunc',
  async (values: { activityBlogId: string }) => {
    const data1 = JSON.stringify({
      query: `query Anonymous_activityBlog($activityBlogId: String!) {
      anonymous_activityBlog(activityBlogId: $activityBlogId) {
                _id  
        duration
        fee
        location {
          _id
          address {
            description
            title
          }
          city
          country
          district
          lat
          long
          parking
        }     
         listing {
         companionship
         reviews {
            count
            data {
              _id
              comment
              createdAt
              createdBy {
                _id
                displayImageUrl
                displayName
              }
              rating
              title
            }
          }
          exteriorOrganizer {
            _id
            contact {
              phoneNumber
              phoneNumber2
              email
            }
            details
            imageUrl
            name
            socialMedia {
              facebook
              instagram
              twitter
              website
              youtube
            }
          }
          category
          images
          title
          description
          coverImage
          format
          ageInterval
        }
        schedule {
          startDate
          endDate
          openHour
          closeHour
          days {
            _id
            activityBlog {
              _id
            }
            date
            day
            startTime
            endTime
            createdAt
            updatedAt
          }
        }
        additionalDetails
        externalLink
        externalMail
        externalPhoneNumber
      }
    }`,
      variables: {
        activityBlogId: values?.activityBlogId ?? null,
      },
    });

    const config = initialConfig(process.env.REACT_APP_BASE_URL_ACTIVITY || '', data1, '');

    const response = axios(config)
      .then((res) => {
        const data = res.data;
        return data;
      })
      .catch((err) => err);

    const data = await response;
    return data;
  }
);

const anonymous_activityBlog = createSlice({
  name: 'anonymous_activityBlog',
  initialState,
  reducers: {
    clearAnonymousActivityBlogData: (state) => {
      state.anonymous_activityBlogData = {};
      state.anonymous_activityBlogError = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(anonymous_activityBlogFunc.pending, (state) => {
      state.anonymous_activityBlogLoading = true;
    });
    builder.addCase(anonymous_activityBlogFunc.fulfilled, (state, action) => {
      state.anonymous_activityBlogLoading = false;
      state.anonymous_activityBlogData = action.payload?.data?.anonymous_activityBlog;
      state.anonymous_activityBlogError = action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(anonymous_activityBlogFunc.rejected, (state, action) => {
      state.anonymous_activityBlogLoading = false;
      state.anonymous_activityBlogError = action.error;
    });
  },
});

export const { clearAnonymousActivityBlogData } = anonymous_activityBlog.actions;
export default anonymous_activityBlog.reducer;
